export const UNIT_CATEGORY = [
  { text: 'Bumi', value: 'bumi' },
  { text: 'Tenanted', value: 'tenanted' },
  { text: 'Rent-To-Own', value: 'rent_to_own' },
];

export default UNIT_CATEGORY;
